<script lang="ts">
  import { InlineNotification } from 'carbon-components-svelte';

  import DataFeedEntitlementsTable from './entitlements-table/DataFeedEntitlementsTable.svelte';
  import FeedInventoryTable from './FeedInventoryTable.svelte';

  import { DataInventoryServiceIds } from '../../../../../shared/constants';
  import type { EntitlementsController } from '../../../../domains/entitlements/entitlements-controller';
  import type { EntitlementsModel } from '../../../../domains/entitlements/entitlements-model';
  import type { EntitlementsParams, ResourceKey } from '../../../../domains/entitlements/entitlements-types';

  export let data: EntitlementsParams, model: EntitlementsModel, controller: EntitlementsController, serviceId: number;

  const { errors, feedInventory } = model;

  $: errorMessages = Object.entries($errors)
    .filter((entry): entry is [ResourceKey, string] => entry[0] !== 'expiredEntitlements' && Boolean(entry[1]))
    .map(([, message]) => message);

  $: supportsObjectRestore =
    serviceId === DataInventoryServiceIds.AWS_ARBITRATED_PCAPS || serviceId === DataInventoryServiceIds.AWS_RAW_FEEDS;
</script>

{#if errorMessages.length > 0}
  {#each errorMessages as message}
    <InlineNotification lowContrast hideCloseButton kind="error" subtitle={message} />
  {/each}
{:else}
  <FeedInventoryTable
    {serviceId}
    feedInventory={$feedInventory}
    on:add-feeds={({ detail }) => model.addDraftEntitlements(detail.feeds, detail.options)}
  />
  <DataFeedEntitlementsTable {data} {model} {controller} {supportsObjectRestore} />
{/if}
